<template>
    <rkm-area
        no-margin-top
        title="Desenvolvimento da criança"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Alterações fenotípicas"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-table
                                :fields="getAlteracoesFenotipicasFields()"
                                :items="item.puericultura.alteracoesFenotipicas"
                                hide-filters
                                hide-pagination
                            >
                                <template v-slot:cell(resposta)="{item}">
                                    {{item.isPresente ? 'Presente' : (item.isPresente === false ? 'Ausente' : 'Não informado')}}
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Fatores de risco"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-table
                                :fields="getFatoresRiscoFields()"
                                :items="item.puericultura.fatoresRisco"
                                hide-filters
                                hide-pagination
                            >
                                <template v-slot:cell(resposta)="{item}">
                                    {{item.isPresente ? 'Presente' : (item.isPresente === false ? 'Ausente' : 'Não informado')}}
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Marcos de desenvolvimento"
                    type="fieldset"
                >
                    <rkm-row
                        v-for="(marcoDesenvolvimento, index) in item.puericultura.marcosDesenvolvimento"
                        :key="index"
                        class="mb-3"
                    >
                        <rkm-col cols="12">
                            <rkm-list-group>
                                <rkm-list-group-item
                                    class="rkm-list-group-item"
                                    v-rkm-toggle="uniqueId(`rkm-collapse-${index}`)"
                                >
                                    <rkm-row>
                                        <rkm-col
                                            class="align-self-center"
                                            cols="6"
                                        >
                                            <strong>{{marcoDesenvolvimento.descricao}}</strong>
                                        </rkm-col>

                                        <rkm-col
                                            class="align-self-center text-right"
                                            cols="6"
                                            style="font-size: 20px;"
                                        >
                                            <rkm-icon
                                                v-for="pergunta in marcoDesenvolvimento.perguntas"
                                                :key="pergunta.id"
                                                class="ml-1"
                                                v-bind="getIconProps(marcoDesenvolvimento, pergunta)"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-list-group-item>
                            </rkm-list-group>

                            <rkm-collapse
                                :id="uniqueId(`rkm-collapse-${index}`)"
                                class="rkm-collapse"
                            >
                                <rkm-table
                                    :fields="getMarcosDesenvolvimentoFields(marcoDesenvolvimento.showAlcancadoCom)"
                                    :items="marcoDesenvolvimento.perguntas"
                                    class="p-2"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(descricao)="{item}">
                                        {{item.descricao}}
                                    </template>

                                    <template v-slot:cell(resposta)="{item}">
                                        {{item.isPresente ? 'Presente' : (item.isPresente === false ? 'Ausente' : 'Não informado')}}
                                    </template>
                                </rkm-table>
                            </rkm-collapse>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <p class="m-0">
                    <rkm-icon
                        color="#8F8FA2"
                        icon="minus-circle"
                    /> Não avaliado
                    <rkm-icon
                        class="ml-1"
                        color="#40A42B"
                        icon="check-circle"
                    /> Presente
                    <rkm-icon
                        class="ml-1"
                        color="#E76F00"
                        icon="exclamation-triangle"
                    /> Presente com atraso
                    <rkm-icon
                        class="ml-1"
                        color="#F75B60"
                        icon="times-circle"
                    /> Ausente
                </p>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    methods: {
        getAlteracoesFenotipicasFields() {
            return [
                {key: 'descricao', label: 'Pergunta'},
                {key: 'status', label: 'Status', formatter: v => v || '-'},
                {class: 'col-min', key: 'resposta', label: 'Resposta'},
            ]
        },
        getFatoresRiscoFields() {
            return [
                {key: 'descricao', label: 'Pergunta'},
                {key: 'status', label: 'Status', formatter: v => v || '-'},
                {class: 'col-min', key: 'resposta', label: 'Resposta'},
            ]
        },
        getMarcosDesenvolvimentoFields(showAlcancadoCom) {
            const fields = [
                {key: 'descricao', label: 'Pergunta'},
                {key: 'status', label: 'Status', formatter: v => v || '-'},
                {class: 'col-min', key: 'resposta', label: 'Resposta'},
            ]

            if (showAlcancadoCom) {
                fields.push({key: 'alcancadoComAnos', label: 'Alcançado com (anos)', formatter: v => v || '-'})
                fields.push({key: 'alcancadoComMeses', label: 'Alcançado com (meses)', formatter: v => v || '-'})
            }

            return fields
        },
        getIconProps(marcoDesenvolvimento, pergunta) {
            let props = {
                title: pergunta.descricao
            }

            if (pergunta.isPresente === null) {
                props.color = "#8F8FA2"
                props.icon = "minus-circle"
            } else if (pergunta.isPresente) {
                const alcancadoMeses = (pergunta.alcancadoComAnos * 12) + pergunta.alcancadoComMeses

                if (marcoDesenvolvimento.showAlcancadoCom && alcancadoMeses > marcoDesenvolvimento.mesesFinal) {
                    props.color = "#E76F00"
                    props.icon = "exclamation-triangle"
                } else {
                    props.color = "#40A42B"
                    props.icon = "check-circle"
                }
            } else {
                props.color = "#F75B60"
                props.icon = "times-circle"
            }

            return props
        },
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>